export default "__VITE_ASSET__673d6839__"